import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    status: {},
    error: null,
    loading: true,
};

export const postStatusInsurance = createAsyncThunk(
    "insurance/postStatusInsurance",
    async ({ data }, thunkAPI) => {
        const headers = {
            "api-version": "v1",
            "Ocp-Apim-Subscription-Key": "08ed34ad38d34939ba9888480eba417d",
        };
        const body = {
            token: data?.token,
            status: data?.status,
            authCode: data?.authCode,
            client: data?.client,
            result: data?.result,
        }
        let url = `${process.env.REACT_APP_PALIDIN_ENDPOINT_DEV}v3/webid/insurance/process`;

        try {
            const response = await axios.post(url, body, { headers });

            if (response?.data) {
                return {
                    status: response?.data,
                };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: error.response.data });
        }
    }
);


export const insuranceSlice = createSlice({
    name: "Insurance",
    initialState,
    reducers: {
        reset: (state) => {
            return initialState;
        },
    },

    extraReducers: (builder) => {
        builder.addCase(postStatusInsurance.fulfilled, (state, action) => {
            state.status = action.payload?.status;
        });
        builder.addCase(postStatusInsurance.rejected, (state, action) => {
            state.status = initialState.status;
        });
    },
});

export const { reset } = insuranceSlice.actions;
